import { useState, useEffect } from "react";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import Header from '../shared/components/Header'
import { useDispatch, useSelector } from "react-redux";
import { fetchReconstruidos } from "../../../../redux/reconstruidos";
import { toast } from "react-toastify";
import { setErrorMessage } from "../shared/helpers/functionalities";
import { RECONSTRUIDOS_API } from "../shared/services/reconstruidos";
import ActionsMenu from "../shared/components/ActionsMenu";
import { getActions } from "../DesguacesOffline/actions";

export default function Reconstruidos() {
  const dispatch = useDispatch();
  const { page } = useParams();
  const currPage = parseInt(page);
  let navigate = useNavigate();
  const [currentPage, setPage] = useState(currPage);
  const reconstruidos = useSelector(state => state.reconstruidos);
  const searcher = useSelector((state) => state.search);
  
  useEffect(() => {
    dispatch(fetchReconstruidos(currPage, getQuery()));
  }, [searcher]);

  const getQuery = () => {
    const isEmpty = Object.values(searcher).every(x => x === null || x === '');
    let query = !isEmpty ? '&search=' + (searcher?.search ? searcher?.search : '')
    : null;

    return query;
  }

  const handleSearch = (searchData) => {
    setPage(1);
    navigate(`/reconstruidos/${1}`);
    dispatch({type: "search/set", payload: searchData});     
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    navigate(`/reconstruidos/${newPage}`);
    dispatch(fetchReconstruidos(newPage, getQuery()));
  }

  const getPaginationCount = () => {
    var totalPages = reconstruidos?.total_items < 15 ? 1 : Math.ceil(reconstruidos?.total_items / 15);
    return totalPages ? parseInt(totalPages) : 0;
  }

  const handleViewSolicitudes = () => navigate('/solicitudes/1', {replace: true} )

  const handleAction = (action, reconstruido) => {
    if(action === 'enable') {
      handleToggle(reconstruido, true)
    } else if(action === 'disable') {
      handleToggle(reconstruido, false)
    }
  }

  const handleToggle = async(reconstruido, enable) => {
    dispatch({type: 'loading/set', payload: true});
    const response = await RECONSTRUIDOS_API.update({id: reconstruido.id, activo: enable})
    .catch(function (error) {
      toast.error(setErrorMessage(error))
      dispatch({type: 'loading/set', payload: false});
    });

    if(response && response.success) {
      dispatch({type: 'loading/set', payload: false});
      toast.success(response.message)
      dispatch(fetchReconstruidos(currentPage, getQuery()));
    }
  }

  return (
    <div className="content pt-3">
      <Header 
        viewSearch={true}
        onSearch={handleSearch}
      ></Header>

      <div className="w-100 d-flex flex-column align-items-end mt-4">
        <div className="d-flex align-items-center">
            <button className="btn btn-default" onClick={handleViewSolicitudes}>Solicitudes</button>
        </div>

       
        <div className="w-100 content-table">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>nombre</th>
                  <th>email</th>
                  <th className="text-center">telefono</th>
                  <th>tipo pieza</th>
                  <th className="text-center">activo</th>
                  <th className="text-center">acciones</th>
                </tr>
              </thead>

              <tbody>
                { reconstruidos.reconstruidos?.map((reconstruido) => {
                  return (
                    <tr key={reconstruido.id}>
                      <td className="text-uppercase">{reconstruido.nombre}</td>
                      <td>{reconstruido.email}</td>
                      <td className="text-center">{reconstruido.telefono}</td>
                      <td>
                          { reconstruido.tipo_piezas.map((tipo, i) => {
                              return (
                                  <span key={'tipo-' + i}>
                                      {tipo.nombre}
                                      
                                      { i >= 0 && i < reconstruido.tipo_piezas.length-1 ? <span className="mx-2">|</span> : ''}
                                  </span>
                              )
                          })}
                      </td>
                      <td className="text-center">
                        <span className={reconstruido.activo ? 'text-green' : 'text-danger'}>
                          <b>{reconstruido.activo ? 'SI' : 'NO'}</b>
                        </span>
                      </td>
                      <td className="text-center">
                        <ActionsMenu 
                            options={getActions(reconstruido)}
                            onAction={(action) => handleAction(action, reconstruido)}
                        />
                      </td>
                    </tr>
                  )
                }) 
                }
                </tbody>
            </table>
          </div>
        </div>

        <Pagination 
          className="mt-3" 
          count={getPaginationCount()} 
          page={currentPage} 
          onChange={handleChangePage} 
        />
      </div>
    </div>
  )
}